
export const LIST_ALL_MENU_ITEMS = `query ($pageSize: Int, $pageNumber: Int) {
  list_all_menu_items(page_size: $pageSize, page_number: $pageNumber) {
    message
    data {
      _id
      item_name
      price
      tax_rate
      category
      status
    }
    hasMore
  }
}`;


export const ADD_NEW_MENU_ITEM = `mutation (
  $item_name: String!
  $price: Float!
  $tax_rate: Float
  $category: String
  $status: Boolean
) {
  add_new_menu_item(
    item_name: $item_name
    price: $price
    tax_rate: $tax_rate
    category: $category
    status: $status
  ) {
    message
  }
}`;

export const LIST_MENU_ITEM_DETAILS = `query ($id: String) {
  list_menu_item_details(_id: $id) {
    message
    data {
      _id
      item_name
      price
      tax_rate
      category
      status
    }
  }
}`;

export const UPDATE_MENU_ITEM = `mutation (
  $_id: String!
  $item_name: String!
  $price: Float!
  $tax_rate: Float
  $category: String
  $status: Boolean
) {
  update_menu_item(
    _id: $_id
    item_name: $item_name
    price: $price
    tax_rate: $tax_rate
    category: $category
    status: $status
  ) {
    message
  }
}`;

